import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { api } from '../../app/Api/ApiSlice'
import { NavLink,Outlet } from 'react-router-dom';
import UserImage from "../../assets/user.png"


const UserPage = () => {
    const { user } = useParams();
    const [userInfo, setUserInfo] = useState({});
    const [userPosts, setUserPosts] = useState([])
    const [isLoading,setIsLoading] = useState(false)

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await api.get(`/users/${user}`)
                // console.log(response)
                if (response.status === 200) {
                    setIsLoading(false)
                    setUserInfo(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message);
            }
        };

        fetchUser();
    }, [user]);

    if (!user) {
        return <div>User not found.</div>;
    }

    return (
        <div className="profile-page-container">
            <div className="profile-page-menu">
                <div className='user-detail'>
                    <h2 className="content-header">Profile</h2>
                    <div className="userdata">
                        <img src={UserImage} alt="" className="home-user-image" />
                        <h3 className="username">{userInfo?.firstname} {userInfo?.lastname}</h3>
                    </div>
                    <div className="user-community">
                        <NavLink to={`/user/${user}/about`}>
                            <p className="community">About</p>
                        </NavLink>
                        <NavLink to={`/user/${user}/`}>
                            <p className="community">Posts</p>
                        </NavLink>
                        <NavLink to={`/user/${user}/friends`}>
                            <p className="community">{`Friends (${userInfo.friendsCount ? userInfo.friendsCount : 0})`}</p>
                        </NavLink>
                        <NavLink to={`/user/${user}/followers`}>
                            <p className="community">{`Followers (${userInfo.followers ? userInfo.followers : 0})`}</p>
                        </NavLink>
                        <NavLink to={`/user/${user}/followings`}>
                            <p className="community">{`Followings (${userInfo.followings ? userInfo.followings : 0})`}</p>
                        </NavLink>
                        <NavLink to={`/user/${user}/organizations`}>
                            <p className="community">Organizations</p>
                        </NavLink>
                        <NavLink to="/chats">
                            <p className="community">{`Messages`}</p>
                        </NavLink>
                    </div>
                </div>
            </div>
            <div className="profile-page-content">
                <Outlet />
            </div>
        </div>
    )
};

export default UserPage;
